// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
const colors = {
    blue100: "rgba(232, 242, 250, 1)",
    blue200: "rgba(187, 221, 250, 1)",
    blue300: "rgba(141, 198, 247, 1)",
    blue400: "rgba(83, 165, 237, 1)",
    blue500: "rgba(34, 130, 214, 1)",
    blue600: "rgba(13, 101, 179, 1)",
    blue700: "rgba(0, 71, 133, 1)",
    blue800: "rgba(5, 54, 97, 1)",
    blue900: "rgba(8, 42, 71, 1)",
    blue1000: "rgba(9, 26, 41, 1)",
    neutral0: "rgba(249, 249, 249, 1)",
    neutral100: "rgba(242, 242, 242, 1)",
    neutral200: "rgba(222, 222, 222, 1)",
    neutral300: "rgba(199, 199, 199, 1)",
    neutral400: "rgba(173, 173, 173, 1)",
    neutral500: "rgba(143, 143, 143, 1)",
    neutral600: "rgba(115, 115, 115, 1)",
    neutral700: "rgba(92, 92, 92, 1)",
    neutral800: "rgba(71, 71, 71, 1)",
    neutral900: "rgba(54, 54, 54, 1)",
    neutral1000: "rgba(38, 38, 38, 1)",
    red100: "rgba(250, 241, 240, 1)",
    red200: "rgba(250, 216, 212, 1)",
    red300: "rgba(250, 188, 182, 1)",
    red400: "rgba(250, 151, 142, 1)",
    red500: "rgba(245, 97, 83, 1)",
    red600: "rgba(218, 44, 27, 1)",
    red700: "rgba(184, 27, 13, 1)",
    red800: "rgba(143, 25, 14, 1)",
    red900: "rgba(102, 27, 20, 1)",
    red1000: "rgba(69, 27, 23, 1)",
    green100: "rgba(225, 250, 227, 1)",
    green200: "rgba(187, 241, 191, 1)",
    green300: "rgba(136, 216, 141, 1)",
    green400: "rgba(66, 184, 74, 1)",
    green500: "rgba(16, 160, 25, 1)",
    green600: "rgba(3, 132, 11, 1)",
    green700: "rgba(5, 107, 12, 1)",
    green800: "rgba(7, 84, 12, 1)",
    green900: "rgba(9, 64, 13, 1)",
    green1000: "rgba(10, 46, 12, 1)",
    orange100: "rgba(250, 245, 240, 1)",
    orange200: "rgba(250, 231, 212, 1)",
    orange300: "rgba(250, 216, 182, 1)",
    orange400: "rgba(250, 196, 142, 1)",
    orange500: "rgba(245, 164, 83, 1)",
    orange600: "rgba(255, 143, 31, 1)",
    orange700: "rgba(184, 98, 13, 1)",
    orange800: "rgba(143, 79, 14, 1)",
    orange900: "rgba(102, 61, 20, 1)",
    orange1000: "rgba(69, 46, 23, 1)",
    primaryLight: "rgba(232, 242, 250, 1)",
    primary: "rgba(13, 101, 179, 1)",
    linkDark: "rgba(83, 165, 237, 1)",
    linkLight: "rgba(13, 101, 179, 1)",
    textDisabledDark: "rgba(92, 92, 92, 1)",
    textSecondaryDark: "rgba(199, 199, 199, 1)",
    textBodyDark: "rgba(251, 251, 251, 1)",
    textHeadlinesDark: "rgba(251, 251, 251, 1)",
    textDisabledLight: "rgba(199, 199, 199, 1)",
    textSecondaryLight: "rgba(115, 115, 115, 1)",
    textBodyLight: "rgba(38, 38, 38, 1)",
    textHeadlinesLight: "rgba(38, 38, 38, 1)",
    primaryDark: "rgba(5, 54, 97, 1)",
    neutralLight: "rgba(249, 249, 249, 1)",
    disabled: "rgba(199, 199, 199, 1)",
    neutral: "rgba(115, 115, 115, 1)",
    dark: "rgba(71, 71, 71, 1)",
    destructiveLight: "rgba(250, 216, 212, 1)",
    destructive: "rgba(218, 44, 27, 1)",
    successLight: "rgba(225, 250, 227, 1)",
    warningLight: "rgba(250, 231, 212, 1)",
    success: "rgba(3, 132, 11, 1)",
    warning: "rgba(255, 143, 31, 1)",
};
module.exports = colors;
//# sourceMappingURL=colors.js.map